namespace Areas.ChangeManagement.Profile{
    "use strict";


    //select Account
    function accountDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#ChangeManagementProfileForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.AccountId = data.accountId;
            formData.AccountName = data.accountName;

            form.option("formData", formData);

        }
    }

    export function selectAccount() {
        const form: any = $("#ChangeManagementProfileForm").dxForm("instance");

        const accountLookupDialog =
            new Areas.Dialogs.AccountDialog(accountDialogClosing());
    }


    //select Contract
    function contractDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#ChangeManagementProfileForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.ContractId = data.contractId;
            formData.ContractName = data.contractName;
            formData.ContractAmount = data.contractAmount;
            formData.ContractType = data.contractType;

            form.option("formData", formData);

        }
    }

    export function selectContract() {
        const form: any = $("#ChangeManagementProfileForm").dxForm("instance");

        const contractLookupDialog =
            new Areas.Dialogs.ContractDialog(contractDialogClosing());
    }


    //contact lookup
    export function selectContractor() {
        const form: any = $("#ChangeManagementProfileForm").dxForm("instance");
        const parameters = { accountId: form.option("AccountId") };

        const accountTeamLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("Contractor"), parameters);
    }

    export function selectArchitect() {
        const form: any = $("#ChangeManagementProfileForm").dxForm("instance");
        const parameters = { accountId: form.option("AccountId") };

        const accountTeamLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("Architect"), parameters);
    }

    export function selectCM() {
        const form: any = $("#ChangeManagementProfileForm").dxForm("instance");
        const parameters = { accountId: form.option("AccountId") };

        const accountTeamLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("CM"), parameters);
    }

    export function selectCoordinator() {
        const form: any = $("#ChangeManagementProfileForm").dxForm("instance");
        const parameters = { accountId: form.option("AccountId") };

        const accountTeamLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("Coordinator"), parameters);
    }

    function accountTeamDialogClosing(buttonId: string) {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#ChangeManagementProfileForm").dxForm("instance");
            const formData: any = form.option("formData");

            if (buttonId === "Contractor") {
                formData.ContractorContactId = data.contactId;
                formData.ContractorContactName = data.displayName;
                formData.ContractorCompanyName = data.companyName;

            } else if (buttonId === "CM") {
                formData.CMContactId = data.contactId;
                formData.CMContactName = data.displayName;
                formData.CMCompanyName = data.companyName;

            } else if (buttonId === "Coordinator") {
                formData.CoordinatorContactId = data.contactId;
                formData.CoordinatorContactName = data.displayName;
                formData.CoordinatorCompanyName = data.companyName;

            } else if (buttonId === "Architect") {
                formData.ArchitectContactId = data.contactId;
                formData.ArchitectContactName = data.displayName;
                formData.ArchitectCompanyName = data.companyName;
            }

            form.option("formData", formData);

        }
    } 


    export function goToActions(projectInfoId: number) {
        return (e: any) => {
            if (e.value == 1) {
                Areas.ChangeManagement.Profile.goToSharePoint();
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                Areas.ChangeManagement.Profile.goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    export function goToSharePoint() {
        const dataGrid = $("#ChangeManagementProfilesGrid").dxDataGrid("instance");
        var sharePointLink = dataGrid.option("sharePointLink") as string;
        if (isNotEmpty(sharePointLink)) {
            Areas.websiteSharePoint(sharePointLink);
        }
    }

    export function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }
}
